<template>
  <img
    :src="`/images/flags/${(country || 'GB').toLowerCase()}.png`"
    loading="lazy"
    :style="{ width: `${100}%` }"
  />
</template>

<script>
export default {
  props: {
    country: { type: String, required: true },
    size: { type: Number, default: 40 }
  }
}
</script>
